import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlashAutoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flash_auto"}/>
}
